<div>


    <div class="page-title">
        <h4 translate>HOME_PAGE.SHOP</h4>
    </div>


    <div class="shop-page">
        <div>
            <div class="grid-container" #shopElement>
                <div class="grid-item" *ngFor="let item of shopList; let i = index">
                    <taly-shop-card [shop]="item" />
                </div>
            </div>

            <ng-container *ngIf="this.totalRecords > this.pageSize">
                <button (click)="loadMoreShope()" [disabled]="this.currentPage == this.totalPages"
                    class="btn btn-outline read-more" translate> BUTTON.SEE_MORE </button>
            </ng-container>
        </div>

    </div>
    <div class="lets-shopping" [class.arebic-content]="textDirection == 'rtl'">
        <div class="col-5 text-title">
            <div class="shop-title">
                <h4 translate>SHOP_PAGE.SHOP_TITLE</h4>
                <p translate>SHOP_PAGE.SHOP_DESC</p>
            </div>

        </div>
        <div class="col-5 img-container ">
            <div class=" shop-img desktop">
                <img src="assets/images/shop-img.svg" alt="shop-img">
            </div>
            <div class="shop-img mobile">
                <img src="assets/images/shops-mob-img.svg" alt="shop-img">
            </div>
        </div>
    </div>
</div>